(function () {
  var resizeTimer;

  function syncSwatchHeights() {
    var $ = window.jQuery;
    if (!$) return;

    $('.card-swatch-block').each(function () {
      var width = $(this).width();
      if (width) $(this).css('height', width + 'px');
    });
  }

  function initVariantSwatches(context) {
    var $ = window.jQuery;
    if (!$) return;

    var $context = context ? $(context) : $(document);
    var $sliders = $context.find('[data-itg-card-swatches]');

    if ($context.is && $context.is('[data-itg-card-swatches]')) {
      $sliders = $sliders.add($context);
    }

    $sliders.each(function () {
      var $slider = $(this);
      if (!$slider.children('.card-swatch-block').length) return;

      $slider.addClass('itg');

      if ($.fn.slick && !$slider.hasClass('slick-initialized') && $slider.children('.card-swatch-block').length > 1) {
        $slider.slick({
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    });

    window.setTimeout(syncSwatchHeights, 200);
  }

  function activateVariantSwatch(swatch, event) {
    if (event) event.preventDefault();

    var card = swatch.closest('.custom-card-product');
    if (!card) return;

    var href = swatch.getAttribute('data-var-url');
    var imageId = swatch.getAttribute('data-var-image-id');

    if (imageId) {
      var targetImage = card.querySelector('[data-img-id="' + imageId + '"]');
      var slider = card.querySelector('.card__slider');

      if (targetImage && slider) {
        var targetIndex = parseInt(targetImage.getAttribute('data-index'), 10);
        var button = targetIndex === 0
          ? card.querySelector('[data-bstr-slider-button="-"]')
          : card.querySelector('.slider__button--next, [data-bstr-slider-button="+"]');

        if (!isNaN(targetIndex) && button) {
          slider.setAttribute('data-bstr-slider-current', targetIndex === 0 ? '1' : String(targetIndex - 1));
          button.click();
        }
      }
    }

    if (href) {
      card.querySelectorAll('a[href]').forEach(function (link) {
        link.setAttribute('href', href);
      });
    }
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.card-swatch-block');
    if (swatch) activateVariantSwatch(swatch, event);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var swatch = event.target.closest('.card-swatch-block');
    if (swatch) activateVariantSwatch(swatch, event);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initVariantSwatches(document);
  });

  window.addEventListener('load', function () {
    initVariantSwatches(document);
  });

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(syncSwatchHeights, 150);
  });

  if (window.BoosterTheme && BoosterTheme.events && BoosterTheme.events.on) {
    BoosterTheme.events.on('booster:content:update', function () {
      initVariantSwatches(document);
    });
  }
})();
